// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-container[data-v-45e11ff8] .ant-form-item-label {\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
